import { Component } from '@angular/core';
import { VehicleExplorer } from './features/vehicle-explorer/vehicle-explorer';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [VehicleExplorer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly showSwaggerLink = environment.envName !== 'production';
}
